export default __webpack_public_path__ + "img/45936de27edf994fb1a766c2aa1d5124.png";